import React, { useEffect, useState, } from 'react';
import { Link, } from 'react-router-dom';

import $ from 'jquery';

import useAuth from '../../controllers/users/useAuth';

import {
    checkIfUserIsMaster, responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, languageObjGet, isUndNullEmp, dataTableLanguaje, LoadingSection, buttonProcessGet,
    processEvaluateGet, awaitDelay,
    expenseCenceptTypesGet,
} from '../../helpers/settings';

import Menu from '../main/Menu';
import ConceptAddEdit from './ConceptAddEdit';
import ConceptVariations from './ConceptVariations';
import BuildingHeader from '../buildings/BuildingHeader';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingsByUserGetAsync } from '../../controllers/apartments/apartmentUsers';
import { buildingModelGet } from '../../models/buildings/building';
import axios from 'axios';
import { conceptModelGet } from '../../models/expenses/concept';
import Swal from 'sweetalert2';

const currentMethod = 'Concepts';

const { app, collections: dbColle, colors, icons, labels, messages, react, } = globalSettings;
const { backend, } = app;
const { properties: dbProps, } = dbColle;
const { operators: dbOpera, } = react?.firebase;

export default function Concepts({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result = {};
    let dataObj = {};
    let headerObj = {};
    const auth = useAuth();
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    const [showModal, setShowModal] = useState(false);
    const [showLoading, setShowLoading] = useState({ buildings: true, expenseConcepts: true, });
    const [btnAddDisabled, setBtnAddDisabled] = useState(true);
    const [processValues, setProcessValues] = useState({
        type: 0,
        dtId: 'dtConcepts',
        dtRowIndex: 0,
    });
    //#endregion variables

    //#region concepts
    const dtConceptsId = 'dtConcepts';
    const [concept, setConcept] = useState({});
    const [expenseConceptTypes, setExpenseConceptTypes] = useState([{ id: 0, description: '', }]);
    const [btnConceptsAsyncDisabled, setBtnConceptsAsyncDisabled] = useState(true);
    //#endregion concepts

    //#region expense concept (variation)
    const [variation, setVariation] = useState({});
    const [showModalVariations, setShowModalvariations] = useState(false);
    //#endregion expense concept (variation)

    //#region buildings
    const buildingsId = 'buildings';
    const [building, setBuilding] = useState({});
    const [buildings, setBuildings] = useState([]);
    //#endregion buildings

    //#region others
    const controls = {
        buttons: {
            // save: {
            //     id: 'btnCreate',
            //     className: 'btn btn-outline-warning mx-1',
            // },
            // back: {
            //     id: 'btnBack',
            //     className: '',
            // },
            // close: {
            //     id: 'btnClose',
            //     className: 'close btn-danger fas fa-window-close',
            // },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            expenseConcepts: {
                buttons: {
                    create: {
                        className: 'btn btn-outline-success float-right btn-sm',
                        id: 'btnDtExpenseConceptsCreate',
                    },
                    // delete: {
                    //     className: 'btn btn-outline-danger float-right btn-sm mx-1',
                    //     id: 'btnDtExpenseConceptsDelete',
                    // },
                },
                icons: {
                    create: {
                        id: 'iconDtExpenseConceptsCreate',
                        className: icons?.plusCircle,
                    },
                    // delete: {
                    //     id: 'iconDtExpenseConceptsDelete',
                    //     className: icons?.trash,
                    // },
                },
                inputs: {
                    search: {
                        id: `${dtConceptsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtConceptsId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    create: {
                        id: 'spDtExpenseConceptsCreate',
                        className: '',
                    },
                    // delete: {
                    //     id: 'spDtExpenseConceptsDelete',
                    //     className: '',
                    // },
                },
            },
        },
        icons: {
            // save: {
            //     id: 'icoSave',
            //     className: icons?.save,
            // },
            // back: {
            //     id: 'icoBack',
            //     className: icons?.arrowCircleLeft,
            // },
            // close: {
            //     id: 'icoClose',
            //     className: icons?.plusCircle,
            // },
        },
        inputs: {
            // user: {
            //     id: 'inputUser',
            //     className: 'form-control bg-transparent',
            // },
            // title: {
            //     id: 'inputTitle',
            //     className: 'form-control bg-transparent',
            // },
            // comment: {
            //     id: 'inputComment',
            //     className: 'form-control',
            // },
            // statusComment: {
            //     id: 'inputStatusComment',
            //     className: 'form-control bg-transparent text-black',
            // },
        },
        selects: {
            // apartment: {
            //     id: 'selApartmet',
            //     className: 'form-select',
            // },
            // title: {
            //     id: 'selTitle',
            //     className: 'form-select',
            // },
            // icon: {
            //     id: 'selIcon',
            //     className: 'form-select',
            // },
            // status: {
            //     id: 'selStatus',
            //     className: 'form-select',
            // },
        },
        spinners: {
            // save: {
            //     id: 'spSave',
            //     className: '',
            // },
            // back: {
            //     id: 'spBack',
            //     className: '',
            // },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region concepts (methods)
    const conceptsGetAsync = async ({ e = {}, processType_ = 's', subMethod = '', }) => {
        const currentMethod = 'conceptsGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let dtRows = [];
            let isEditLocal = false;
            let buildingIdLocal = '';
            let isDeleteLocal = false;
            let buildingLocal = buildingModelGet({});
            let conceptsLocal = [conceptModelGet({})]
            //#endregion variables

            //#region initialize
            if (!isUndNullEmp({ data: e, subMethod: currentMethod })?.result) {
                e?.preventDefault();
            }

            setBtnAddDisabled(true);
            setBtnConceptsAsyncDisabled(true);
            $(`#${dtConceptsId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            setShowLoading({ buildings: false, expenseConcepts: true, });
            //#endregion initialize

            //#region data get
            buildingIdLocal = $(`#${buildingsId}`)?.val();
            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                buildingLocal = buildings.find(({ id, }) => id === buildingIdLocal) || {};
                setBuilding(buildingLocal);

                //#region data get
                headerObj = {
                    headers: {
                        authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    },
                };
                dataObj = {
                    buildingId: buildingIdLocal,
                    conditionals: [
                        { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: buildingIdLocal, },
                    ],
                    ordersBy: [
                        { field: dbProps?.description, value: 'asc', },
                    ],
                    languageId: languageObj?.id,
                    url: `${backend?.url}${backend?.urlApiV1}${backend?.urlExpenseConcepts}/`,
                };

                result = await axios?.post(
                    dataObj?.url,
                    dataObj,
                    headerObj,
                );

                response = result?.data;

                if (!response?.isSuccess || response?.isWarning) {
                    setShowLoading({ buildings: false, expenseConcepts: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                conceptsLocal = response?.result || [];
                //#endregion data get

                //#region set status button add concept
                setBtnConceptsAsyncDisabled(false);
                //#endregion set status button add concept

                //#region dt data rows
                if (!isUndNullEmp({ data: conceptsLocal, subMethod: currentMethod, })?.result && conceptsLocal?.length > 0) {
                    conceptsLocal?.forEach((detail) => {
                        const processButtonLocal = [
                            {
                                isVisible: true,
                                showDivider: true,
                                isEnabled: true,
                                methodName: backend?.methods?.showVariations,
                                icon: icons?.chartLine,
                                label: labels?.variations?.[languageObj?.id],
                            }
                        ];
                        dtRows.push([
                            detail?.description,
                            expenseConceptTypes?.find(({ id }) => id === detail?.type)?.description || '',
                            buttonProcessGet({
                                id: detail?.id,
                                description: detail?.description,
                                showDetails: false,
                                labelDetails: '',
                                enabledDetails: false,
                                showEdit: true,
                                labelEdit: labels?.edit?.[languageObj?.id],
                                enabledEdit: processEvaluateGet({
                                    object: detail,
                                    property: labels?.process?.en?.toLowerCase(),
                                    process: labels?.edit?.en?.toLowerCase(),
                                    subMethod: currentMethod,
                                })?.result,
                                showDelete: true,
                                labelDelete: labels?.delete?.[languageObj?.id],
                                enabledDelete: processEvaluateGet({
                                    object: detail,
                                    property: labels?.process?.en?.toLowerCase(),
                                    process: labels?.delete?.en?.toLowerCase(),
                                    subMethod: currentMethod,
                                })?.result,
                                processButtons: processButtonLocal,
                                subMethod: currentMethod,
                            })?.result,
                        ])
                    });
                }
                //#endregion dt data rows

                //#region check is enebled btnAdd
                isEditLocal = processEvaluateGet({
                    object: buildingLocal,
                    property: labels?.process?.en?.toLowerCase(),
                    process: labels?.edit?.en?.toLowerCase(),
                    subMethod: currentMethod
                })?.result;

                isDeleteLocal = isEditLocal;
                //#endregion check is enebled btnAdd

                setBtnConceptsAsyncDisabled(false);
                setBtnAddDisabled(!(isEditLocal && isDeleteLocal));
            } else {
                setBuilding({});
                setBtnAddDisabled(true);
                setBtnConceptsAsyncDisabled(true);
            }
            //#endregion data get

            //#region dataTable / query code / datatable data set 
            $(`#${dtConceptsId}`)?.DataTable()?.rows?.add(dtRows)?.draw(true);
            //#endregion dataTable / query code / datatable data set

            setShowLoading({ buildings: false, expenseConcepts: false, });
        } catch (ex) {
            setShowLoading({ buildings: false, expenseConcepts: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const conceptAddGetAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = '';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let buildingIdLocal = $(`#${buildingsId}`)?.val();;
            //#endregion variables

            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                controlsStatusSet({ processType: 1, subMethod: currentMethod, });
                setConcept(
                    conceptModelGet({
                        buildingId: buildingIdLocal,
                        userId: auth?.user?.uid,
                    })
                );

                setProcessValues({ ...processValues, type: 0, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                setShowModal(true);
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else {
                response.msgType = 1;
                response.isWarning = true;
                response.msgText = messages?.youMustSelectBuilding?.[languageObj?.id];
                $(`#${buildingsId}`)?.trigger('focus');
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const conceptEditGetAsync = async ({ id = '', description = '', rowIndex = 0, subMethod = '', }) => {
        const currentMethod = 'conceptEditGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let conceptLocal = conceptModelGet({});
            //#endregion variables

            setShowLoading({ buildings: false, expenseConcepts: true, });

            //#region data get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlExpenseConcepts}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, expenseConcepts: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            conceptLocal = response.result;
            //#endregion data get

            setConcept(conceptLocal);
            setProcessValues({ ...processValues, dtRowIndex: rowIndex, type: 1, });

            setShowModal(true);
            setShowLoading({ buildings: false, expenseConcepts: false, });
        } catch (ex) {
            setShowLoading({ buildings: false, expenseConcepts: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const conceptDeleteAsync = async ({ id = '', description = '', rowIndex = 0, subMethod = '', }) => {
        const currentMethod = 'conceptDeleteAsync';
        let response = responseGet();
        try {
            //#region show message
            let msgTextObj = {
                one: `${labels?.expenseConcept?.[languageObj?.id]}: <b>${description}</b><br/>`,
                //two: `${description}<br/>`,
                two: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            let swalProperties = {
                icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.one}`,
                            showConfirmButton: false,
                        });

                        //#region delete expense concept
                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                languageId: languageObj?.id,
                            },
                            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlExpenseConcepts}/${id}`,
                        };

                        result = await axios.delete(
                            headerObj?.url,
                            headerObj,
                        );

                        response = result?.data;

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                        //#endregion delete expense concept

                        //#region delete expense concept (dataTable)
                        $(`#${dtConceptsId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
                        setProcessValues({ ...processValues, dtRowIndex: 0, type: 0, });
                        //#endregion delete expense concept (dataTable)

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: 0,
                            msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion show message
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const variationsGetAsync = async ({ id = '', subMethod = '', }) => {
        const currentMethod = 'variationsGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ buildings: false, expenseConcepts: true, });

            //#region data get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                buildingId: $(`#${buildingsId}`)?.val(),
                conditionals: [],
                ordersBy: [],
                limit: 0,
                method: backend?.methods?.expenseTemplates?.variationsGet,
                expenseConceptId: id,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlExpenseTemplates}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, expenseConcepts: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            setVariation({ variations: response?.result, expenseConcept: response?.expenseConcept, });
            //#endregion data get

            setShowModalvariations(true);
            setShowLoading({ buildings: false, expenseConcepts: false, });
        } catch (ex) {
            setShowLoading({ buildings: false, expenseConcepts: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion concepts (methods)

    //#region others (methods)
    const dataTablesSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTablesSetAsync';
        let response = responseGet();
        try {
            $(`#${dtConceptsId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.description?.[languageObj?.id], width: '80%', },
                    { title: labels?.type?.[languageObj?.id], width: '15%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                //order: [[1, 'asc'], [0, 'asc']],
                order: [[0, 'asc'],],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtConceptsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const queryCodeSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region methods
            $(`#${dtConceptsId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                e.preventDefault();
                rowIndex = $(`#${dtConceptsId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'edit':
                            conceptEditGetAsync({ id: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            conceptDeleteAsync({ id: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        case backend?.methods?.showVariations:
                            variationsGetAsync({ id: id, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region initialize
            //#endregion initialize

            setShowLoading({ buildings: true, expenseConcepts: true, });

            //#region expenseConceptTypes get
            response = expenseCenceptTypesGet({
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, expenseConcepts: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: processValues?.auth,
                    isLogout: false,
                    languageId: [languageObj?.id],
                    subMethod: currentMethod,
                });
                return;
            }

            setExpenseConceptTypes(response?.result || []);
            //#endregion expenseConceptTypes get

            //#region dataTable set
            response = await dataTablesSetAsync({
                dt: dtConceptsId,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, expenseConcepts: false, });
                return;
            }
            //#endregion dataTable set

            //#region queryCode set
            response = await queryCodeSetAsync({ subMethod: currentMethod, });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, expenseConcepts: false, });
                return;
            }
            //#endregion queryCode set

            //#region buildings get
            response = await buildingsByUserGetAsync({
                userRole: userRole,
                auth: auth,
                urlGoTo: backend?.urlExpenseConcepts,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, expenseConcepts: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }

            if (!isUndNullEmp({ data: response?.result?.buildings, subMethod: currentMethod, })?.result && response?.result?.buildings?.length > 0) {
                setBuildings(response?.result?.buildings);
            }
            //#endregion buildings get

            setShowLoading({ buildings: false, expenseConcepts: false, });
        } catch (ex) {
            setShowLoading({ buildings: false, expenseConcepts: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.dataTables?.expenseConcepts?.icons?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.expenseConcepts?.buttons?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.expenseConcepts?.spinners?.create?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.expenseConcepts?.icons?.create?.id}`)?.addClass(controls?.dataTables?.expenseConcepts?.icons?.create?.className);
                    $(`#${controls?.dataTables?.expenseConcepts?.buttons?.create?.id}`)?.addClass(controls?.dataTables?.expenseConcepts?.buttons?.create?.className);
                    $(`#${controls?.dataTables?.expenseConcepts?.spinners?.create?.id}`)?.addClass(controls?.dataTables?.expenseConcepts?.spinners?.create?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.dataTables?.expenseConcepts?.icons?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.expenseConcepts?.spinners?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region old code
            // $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.password?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.checkBox?.remenberMe?.id}`).attr('disabled', (processType !== 0));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.expenseConcepts?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.expenseConcepts?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.dataTables?.expenseConcepts?.buttons?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, [auth,]) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others (methods)

    return (
        <div>
            <Menu viewName='expenses' process='concepts' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.concept?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.concept?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {/*buildings*/}
                        <BuildingHeader
                            buildingsId={buildingsId}
                            building={building}
                            buildings={buildings}
                            btnSyncDisabled={btnConceptsAsyncDisabled}
                            methodGetAsync={conceptsGetAsync}
                            processType={0}
                            headerSectionValues={{}}
                            showLoading={showLoading?.buildings}
                            languageObj={languageObj} />

                        {/*concepts*/}
                        <div className='row'>
                            <div className='col-12'>

                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.expenseConcepts}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.concept?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.expenseConceptsLogo}></img> - {labels?.concept?.[languageObj?.id]}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div> {/*card header*/}

                                    {/*body*/}
                                    <div className='card-body'>

                                        <div className='row'>
                                            {/* {!showLoading ? */}
                                            <div className='col-md-12'>
                                                {/* {showData ? */}
                                                {/* <div> */}
                                                <button id={controls?.dataTables?.expenseConcepts?.buttons?.create?.id}
                                                    className={controls?.dataTables?.expenseConcepts?.buttons?.create?.className}
                                                    //disabled={btnConceptsAsyncDisabled}
                                                    disabled={btnAddDisabled}
                                                    tooltip='tooltip'
                                                    title={labels?.create?.[languageObj?.id]}
                                                    onClick={(e) => conceptAddGetAsync({ e: e, subMethod: 'btn - create' })}
                                                    type='button'>
                                                    <i id={controls?.dataTables?.expenseConcepts?.icons?.create?.id} className={controls?.dataTables?.expenseConcepts?.icons?.create?.className} /> <span id={controls?.dataTables?.expenseConcepts?.spinners?.create?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtConceptsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                            </div>
                                            {/* : */}
                                            {/* <div></div> */}
                                            {/* } */}
                                            {/* </div> */}

                                            {/* : */}
                                            {/* <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                                    width={40}
                                                    height={40}
                                                    color={colors?.infoColorExp}
                                                    msgText={messages?.processing?.[languageObj?.id]}
                                                    msgOrientation='text-center'
                                                    msgTextMuted={true} /> */}
                                            {/* } */}
                                        </div>

                                    </div> {/*card body*/}

                                    {/*footer*/}
                                    {/* <div className='card-footer'></div> */}

                                </div>{/*card*/}

                            </div>{/*col*/}
                        </div>{/*row*/}

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}

            </div>

            {showModal ?
                <ConceptAddEdit $={$}
                    auth={auth}
                    showModal={showModal}
                    setShowModal={setShowModal}
                    concept={concept}
                    setConcept={setConcept}
                    expenseConceptTypes={expenseConceptTypes}
                    setExpenseCenceptTypes={setExpenseConceptTypes}
                    processValues={processValues}
                    setProcessValues={setProcessValues} />
                :
                <></>
            }

            {showModalVariations ?
                <ConceptVariations $={$}
                    auth={auth}
                    building={building}
                    variation={variation}
                    setVariation={setVariation}
                    expenseConceptTypes={expenseConceptTypes}
                    setExpenseCenceptTypes={setExpenseConceptTypes}
                    showModal={showModalVariations}
                    setShowModal={setShowModalvariations}
                    languageObj={languageObj} />
                :
                <></>
            }
        </div>
    )
}